import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {LoginComponent} from './login.component';
import {UserService} from '../../services/user.service';
import {AccountService} from '../../services/account.service';
import {environment} from '../../../environments/environment';
import {ErisLoginModule} from '../../services/sso/eris-login.module';

@NgModule({
  declarations: [LoginComponent],
  imports: [CommonModule, SharedModule, ErisLoginModule],
  exports: [ErisLoginModule],
  providers: [UserService, AccountService, {
    provide: 'authConf', useValue: {
      authority: environment.stsAuthority,
      client_id: environment.clientId,
      redirect_uri: `${environment.clientRoot}auth-callback?to=signin`,
      post_logout_redirect_uri: `${environment.clientRoot}auth-callback?to=signout`,
      response_type: 'code',
      scope: environment.clientScope
    }
  }]
})

export class LoginModule {
}
